<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { useBreakpoint } from '@/composables/useBreakpoint';
import Toast from 'primevue/toast';

const { isMobile } = useBreakpoint();

let observer = null;

const enableSwipe = (toast) => {
    let startY = 0;
    let currentY = 0;

    const onTouchStart = (e) => {
        startY = e.touches[0].clientY;
        toast.style.transition = 'none';
    }

    const onTouchMove = (e) => {
        e.preventDefault();
        currentY = e.touches[0].clientY;
        const diff = currentY - startY;

        if (diff < 0) {
            toast.style.transform = `translateY(${diff}px)`;
        }
    }

    const onTouchEnd = () => {
        const diff = currentY - startY;
        toast.style.transition = 'transform 0.2s ease, opacity 0.2s ease';

        if (diff < -60) {
            toast.style.transform = 'translateY(-150%)';
            toast.style.opacity = '0';
            setTimeout(() => toast.remove(), 200);
        } else {
            toast.style.transform = 'translateY(0)';
        }
    }

    toast.style.touchAction = 'none';

    toast.addEventListener('touchstart', onTouchStart);
    toast.addEventListener('touchmove', onTouchMove, { passive: false });
    toast.addEventListener('touchend', onTouchEnd);
}

onMounted(() => {
    if (!isMobile.value) return;

    const container = document.body;

    observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.classList && node.classList.contains('p-toast-message')) {
                    enableSwipe(node);
                }
            });
        });
    });

    observer.observe(container, {
        childList: true,
        subtree: true
    });
});

onBeforeUnmount(() => {
    if (observer) {
        observer.disconnect();
    }
});
</script>

<template>
    <Toast
        :position="isMobile ? 'top-center' : 'top-right'"
        :pt:root:style="{
            top: isMobile ? '10px' : '20px',
            maxWidth: '95vw'
        }"
    />
</template>

<style scoped>
:deep(.p-toast-message) {
    will-change: transform;
}
</style>
